import { z } from 'zod';

import { listSearchSchema } from '@/shared/patterns/list-search';

import { installmentBillingFilters, installmentFilters } from './installment.filters';

export { INSTALLMENT_PATH, installmentPath } from './installment.path';

/** Diálogos da lista (`filtros` é o painel de filtros do iPhone, U26); `row` é o parcelamento da linha (Cancelar, Transferir, Registrar, Edição rápida). */
export const installmentListSearch = listSearchSchema({
  ...installmentFilters.shape,
  sheet: z.enum(['new', 'edit', 'cancel', 'transfer', 'register', 'filtros']).optional().catch(undefined),
  row: z.string().optional().catch(undefined),
});

export const INSTALLMENT_DETAIL_SHEETS = [
  'transfer',
  'cancel',
  'communication',
  'simulate',
  'register',
  'settle',
  'bankSlipGenerate',
  'bankSlipDownload',
  'bankSlipEmail',
  'bankSlipCancel',
  'bankSlipDueDate',
  'filtros',
] as const;
export type InstallmentDetailSheet = (typeof INSTALLMENT_DETAIL_SHEETS)[number];

/** O detalhe guarda na URL os filtros, a página e a seleção das cobranças e o diálogo aberto (`billing` = cobrança da linha). */
export const installmentDetailSearch = listSearchSchema({
  ...installmentBillingFilters.shape,
  sheet: z.enum(INSTALLMENT_DETAIL_SHEETS).optional().catch(undefined),
  billing: z.string().optional().catch(undefined),
  selected: z.array(z.string()).optional().catch(undefined),
});
